// --- Core ---
import {FormattedDate, FormattedMessage} from "react-intl";

interface FormattedDateProps {
  value: Date;
}

interface FormatDateTimeProps extends FormattedDateProps {
  /**
   * @deprecated use value instead
   */
  date?: Date;
}

const FormatDateTime = ({date, value}: FormatDateTimeProps) =>
  <FormattedMessage id="datetime" defaultMessage="{time, date, ::dd.MM.yyyy} at {time, date, ::HH:mm}" values={{time: value || date}}/>;

const FormattedOptionalDate = ({value}: FormattedDateProps) =>
  value ? <FormattedDate value={value} day="2-digit" month="2-digit" year="numeric"/> :
    (<FormattedMessage id={"datetime.none"} defaultMessage={"No time specified"}/>);

const FormattedOptionalDateTime = ({value}: FormattedDateProps) => value ? <FormatDateTime value={value}/> :
  (<FormattedMessage id={"datetime.none"} defaultMessage={"No time specified"}/>);

export {
  FormatDateTime,
  FormattedOptionalDate,
  FormattedOptionalDateTime
};
